// src/App.js
import React from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import { companyData } from './data/companyData';
// Import global CSS / Tailwind base styles if needed (depends on setup)
// import './index.css';

function App() {
  return (
    <>
      {/* Global style for smooth scrolling (can be moved to index.css) */}
      <style jsx global>{`
        html {
          scroll-behavior: smooth;
        }
        body {
           /* Apply sans-serif font globally via Tailwind config or here */
           font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
           @apply antialiased text-gray-900; /* Apply base text color and antialiasing */
        }
      `}</style>

      <div className="flex flex-col min-h-screen">
        {/* Pass necessary data to Navbar */}
        <Navbar
            companyName={companyData.name}
            logoUrl={companyData.logoUrl}
        />

        {/* Render the main page content */}
        <div className="flex-grow">
          <HomePage />
        </div>


        {/* Pass necessary data to Footer */}
        <Footer companyName={companyData.name} />
      </div>
    </>
  );
}

export default App;

